import {twMerge} from '@sdox/utils'

import type {IconDefinition} from '@fortawesome/fontawesome-common-types'
import type {SVGProps} from 'react'

export type FaIconProps = SVGProps<SVGSVGElement> & {icon: IconDefinition}

const xmlns = 'http://www.w3.org/2000/svg'

/**
 * Component in order to remove @fortawesome/fontawesome-svg-core
 * from https://github.com/FortAwesome/react-fontawesome/issues/232#issuecomment-1158654385
 *
 * @param props
 * @returns
 */
export function FaIcon(props: FaIconProps) {
  const {icon: iconProps, children, className, ...rest} = props

  const {prefix, iconName, icon} = iconProps
  const [width, height, _ligatures, _unicode, svgPathData] = icon

  const dataFa = `${prefix}-${iconName}`

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      xmlns={xmlns}
      role={'img'}
      aria-hidden={'true'}
      data-fa={dataFa}
      className={twMerge('inline-block size-4 align-[-.125em]', className)}
      {...rest}
    >
      {children}
      {Array.isArray(svgPathData) ? (
        <g fill={'currentColor'}>
          <path d={svgPathData[0]} />
          <path d={svgPathData[1]} />
        </g>
      ) : (
        <path
          fill={'currentColor'}
          d={svgPathData}
        />
      )}
    </svg>
  )
}
